import { createApp } from "vue";
import { createPinia } from "pinia";
import piniaPluginPersistedState from "pinia-plugin-persistedstate";
import VueGtag from "vue-gtag-next";
import router from "@/router/index";
import i18n from "@/i18n/index";
import App from "./App.vue";
import "./styles/tailwind.css";
import "./styles/main.scss";
import initiator from "@/plugins/initiator";
import mitt from "mitt";

// TODO 上线前要删除
// (async () => {
//   const mod = await import("vconsole");
//   const VConsole = mod.default;
//   new VConsole();
// })();


const pinia = createPinia();
pinia.use(piniaPluginPersistedState);
const app = createApp(App);

app.config.globalProperties.$mitt = mitt();
app.use(i18n);
app.use(pinia);
app.use(router);
app.use(VueGtag, {
  property: {
    id: "G-6K3CBT5Z8Y",
  },
});
// app.use(initiator, {});
app.mount("#app");
